<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="content_wrap container">
      <div class="content_title">
        <titleConfig
          :title="
            langSet == 'cn' ? '往届会议嘉宾' : 'Previous Conference Speakers'
          "
          :type="2"
        ></titleConfig>
      </div>
      <div class="list flex flex_wrap" v-loading="loading">
        <div class="item" v-for="(item, index) in list" :key="index">
          <el-image class="img-wrap" :src="item.img" :fit="'cover'"></el-image>
          <div class="title">
            {{ langSet == "cn" ? item.nickname : item.en_nickname }}
          </div>
          <div>{{ langSet == "cn" ? item.describe : item.en_describe }}</div>
        </div>
      </div>
      <div class="page_wrap flex flex_content_center">
        <el-pagination
          v-if="totals > 30"
          background
          layout="prev, pager, next"
          :total="totals"
          :page-size="30"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import { guestsList } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      loading: false,
      list: [],
      totals: 0,
      pageNo: 1,
      pageSize: 30,
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    //25.9.16 获取往届会议嘉宾 dxm
    this.getList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getList() {
      let data = {
        page_no: this.pageNo,
        page_size: this.pageSize,
      };
      this.loading = true;
      const res = await guestsList(data);
      this.list = res.data.lists;
      this.totals = res.data.count;
      this.loading = false;
    },
    currentChange(e) {
      this.pageNo = e;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.content_wrap {
  padding: 80px 0;
  min-height: 500px;
  .content_title {
    margin-bottom: 31px;
  }
  .list {
    .item {
      width: 180px;
      padding: 10px 10px 5px;
      font-size: 14px;
      color: #44435a;
      line-height: 20px;
      cursor: pointer;
      text-align: center;
      margin: 0 16px 30px 0;
      // box-sizing: border-box;
      &:nth-child(6n) {
        margin-right: 0;
      }
      transition: all 0.5s ease-in-out;
      .title {
        font-size: 16px;
        color: #001a33;
        line-height: 22px;
        padding-bottom: 8px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .img-wrap {
        width: 100%;
        height: 250px;
        margin-bottom: 14px;
        border-radius: 20px;
        overflow: hidden;
      }
      &:hover {
        border-radius: 20px;
        box-shadow: 0 3px 10px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }
  .page_wrap {
    margin-top: 40px;
  }
}
@media only screen and (max-width: 1280px) {
  .content_wrap .list .item {
    width: calc(100% / 5 - 30px);
    margin-right: 10px;
    margin-bottom: 20px;
    &:nth-child(6n) {
      margin-right: 20px;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
    .img-wrap {
      height: 225px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    padding: 0.58rem 0;
    .list .item {
      width: calc(100% / 2 - 25px);
      margin-right: 10px;
      &:nth-child(6n) {
        margin-right: 10px;
      }
      &:nth-child(5n) {
        margin-right: 10px;
      }
      &:nth-child(2n) {
        margin-right: 0;
      }
      .img-wrap {
        height: 185px;
      }
    }
  }
}
</style>